export var RangePatternType;
(function (RangePatternType) {
    RangePatternType["startRange"] = "startRange";
    RangePatternType["shared"] = "shared";
    RangePatternType["endRange"] = "endRange";
})(RangePatternType || (RangePatternType = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formatjs/ecma402-abstract/lib/types/date-time.js
// module id = 274
// module chunks = 0